// FormModal.jsx
import React, {useState, useEffect, useCallback, useRef} from 'react';
import { Modal } from 'react-bootstrap';
import { BorrowerLeadGenerationTool } from 'borrower-lead-generation-tool';
import './FormModal.css';

const FormModal = ({ show, onHide, loanType, workflowUrl }) => {

    const [node, setNode] = useState(null);
    const modalBodyRef = useRef(null);

    const formRef = useCallback((node) => {
        setNode(node);
      }, []);

    // Detect blank modal state (form submitted without phone number) and redirect
    useEffect(() => {
        if (!show || !modalBodyRef.current) return;

        const observer = new MutationObserver(() => {
            const body = modalBodyRef.current;
            if (!body) return;
            const form = body.querySelector('form');
            const thankYou = body.querySelector('.blg-row-2, .confirmation-content');
            // If form is gone and no thank you content is visible, redirect
            if (!form && !thankYou) {
                const redirectUrl = workflowUrl || loanType;
                if (redirectUrl) {
                    window.location.href = redirectUrl;
                }
            }
        });

        observer.observe(modalBodyRef.current, { childList: true, subtree: true });

        return () => observer.disconnect();
    }, [show, loanType, workflowUrl]);

    return (
        <Modal size="lg" centered show={show} onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title>Please fill the information below to continue</Modal.Title>
            </Modal.Header>
            <Modal.Body ref={modalBodyRef}>
                <BorrowerLeadGenerationTool
                    leadSource="NET007"
                    loanOfficerUid="DAVE"
                    webPageURL={process.env.REACT_APP_STATE_DOMAIN}
                    statesDomain={process.env.REACT_APP_STATE_DOMAIN}
                    domainNameConsent="lowrates.com"
                    language="en"
                    continueBtnRedirectUrl={loanType}
                    workflowUrl={workflowUrl}
                    mainBtnName="Apply Now"
                />
            </Modal.Body>
        </Modal>
    );
};

export default FormModal;